module.exports = {
  angularModuleName: 'Zill',
  projectName: 'Zill App - Inspiratiemodule',
  projectVersion: 'main',
  environment: 'prod',
  release: 'main',
  projectDescription: 'The zill website.',
  googlAnalytics: {
    enabled: true,
    token: 'G-JPQN2G6CCX'
  },
  apisAndUrls: {
    cachedApi: 'https://cached-api.katholiekonderwijs.vlaanderen',
    api: 'https://api.katholiekonderwijs.vlaanderen',
    searchApi: 'https://search-api.katholiekonderwijs.vlaanderen'
  },
  logging: {
    sentry: {
      enabled: true,
      url: 'https://5d3fa15cbc6040fe9cc34008ea494d08@o268751.ingest.sentry.io/4504475147108352',
      sentryPerformanceSampleRate: 0.03,
      fetchInterceptor: true
    }
  },
  concept: {
    krachtlijnen: '/content/194b5727-4eb9-456b-9c25-f8a4e1f4678d',
    leeruitkomst: '/content/62153b2c-05b5-41ef-8cf6-65c6b9529488',
    ordeningskader: '/content/173b5727-4eed-456b-9c25-f8a4e1f453de'
  },
  support: {
    leerplansite: '/content/dcc48e74-cc9a-44c0-b3e6-bb232b325099',
    selectietool: '/content/3ad248d5-f2d0-4a52-8cfe-56633a95c7dd',
    faq: '/content/3ad248d5-f2d0-4a52-8cfe-56633a95c456'
  },
  BuBao: true,
  anValuesThemeRoot: '/content/16c3e386-54c7-4b74-80e4-1c699ed067b3',
  popup: [
    {
      key: 1,
      title: '',
      body: '<a href="https://pro.katholiekonderwijs.vlaanderen/zin-in-leren-leven-school" target="_blank" ng-click="accept()"><img src="/img/nascholing_flyer.png"><br />Meer info</a>',
      ttl: 14,
      endDate: '2020-09-01T00:00:00Z'
    }
  ]
};



// WEBPACK FOOTER //
// ./web/js/config/settings.js